import { ENDPOINT } from '@old/data/core/endpoints';
import { BACKEND } from '@old/services/core/fetch-backend';
import { transformIntoQueryParamString } from '@old/utils/service';
import { useGlobalStore } from '@old/global-store/use-store';

import { MapInfoData, MapInfoPayload } from './map-info.types';

// deprecated service ref.: mapService_DEPRECATED

// implementado ✅
export async function mapInfoService({ query: rawQuery }: MapInfoPayload) {
  const { organizationId } = useGlobalStore.getState();
  const parse = {
    ...rawQuery,
    organization_id: organizationId,
  };
  const query = transformIntoQueryParamString(parse);

  const { response, data } = await BACKEND.get<MapInfoData>(ENDPOINT.MAP, { query });

  return {
    response,
    summary: data,
  };
}
